import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import { Font, Label } from "@moneyforward/mfx_biz_react_components";
import { FormErrorMessage, FormSelectBox } from "@/components/molecules";
import { useIsSpMode } from "@/hooks";
import { useFormContext } from "react-hook-form";
import {
  COMPANY_OPTIONS_INDUSTRIES_CODE_LARGE,
  COMPANY_OPTIONS_INDUSTRIES_CODE_MIDDLE_RAW,
} from "@/libs/constants";

type Props = {
  nameLarge: string;
  nameMiddle: string;
  labelRequired: boolean;
};

export const IndustriesFormField = ({
  nameLarge,
  nameMiddle,
  labelRequired,
}: Props) => {
  const isSpMode = useIsSpMode();
  const { getValues, setValue } = useFormContext();

  const [industriesCodeMiddle, setIndustriesCodeMiddle] = useState<
    { value: string; label: string }[] | null
  >(null);

  // 業種のステータス管理
  const [industriesCodeLargeValue, setIndustriesCodeLargeValue] = useState<
    string | null
  >(getValues().industriesLarge);

  useEffect(() => {
    if (industriesCodeLargeValue) {
      const industriesCodeMiddleMaster =
        COMPANY_OPTIONS_INDUSTRIES_CODE_MIDDLE_RAW[industriesCodeLargeValue];
      const defaultIndustriesCodeMiddle = Object.entries(
        industriesCodeMiddleMaster
      ).map(([key, value]) => ({
        value: key,
        label: value,
      })) as {
        value: string;
        label: string;
      }[];
      defaultIndustriesCodeMiddle.unshift({ value: null, label: "未選択" });
      setIndustriesCodeMiddle(defaultIndustriesCodeMiddle);

      const currentIndustriesMiddle = getValues("industriesMiddle");
      if (
        !defaultIndustriesCodeMiddle.find(
          (v) => v.value === currentIndustriesMiddle
        )
      ) {
        setValue("industriesMiddle", defaultIndustriesCodeMiddle[0].value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industriesCodeLargeValue, COMPANY_OPTIONS_INDUSTRIES_CODE_MIDDLE_RAW]);

  return (
    <>
      <div css={!isSpMode ? container : {}}>
        <div css={labelWrapper}>
          <Font variant="m" component="p">
            業種(大分類) {labelRequired && <Label variant="required" />}
          </Font>
        </div>
        <div css={inputWrapper}>
          <div css={fieldWrapper}>
            <FormSelectBox
              name={nameLarge}
              placeholder={"未選択"}
              options={COMPANY_OPTIONS_INDUSTRIES_CODE_LARGE}
              onChange={() => {
                setIndustriesCodeLargeValue(getValues().industriesLarge);
              }}
              registerOptions={{
                required: "選択してください",
              }}
            />
            <FormErrorMessage name={nameLarge} />
          </div>
        </div>
      </div>
      <div css={{ marginTop: "8px" }}></div>
      <div css={!isSpMode ? container : {}}>
        <div css={labelWrapper}>
          <Font variant="m" component="p">
            業種(中分類)
          </Font>
        </div>
        <div css={inputWrapper}>
          <div css={fieldWrapper}>
            <FormSelectBox
              name={nameMiddle}
              placeholder={"未選択"}
              options={industriesCodeMiddle ? industriesCodeMiddle : undefined}
            />
            <FormErrorMessage name={nameMiddle} />
          </div>
        </div>
      </div>
    </>
  );
};

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
  flexGrow: 1,
});

const fieldWrapper = css({
  width: "100%",
});
